import * as types from '../../lib/actionTypes.es6';

export const initialState = {
  errors: null,
  claimsList: null,
  loader: false,
};

export default function summaryClaimReducer(state = initialState, action) {
  switch (action.type) {
    case types.SUMMARY_CLAIM_REQUEST:
      return { ...initialState, loader: true };

    case types.SUMMARY_CLAIM_SUCCESS:
      return { ...state, claimsList: action.payload, loader: false };

    case types.SUMMARY_CLAIM_FAILURE:
      return {
        ...state,
        loader: false,
        errors: action.payload,
        claimsList: null,
      };

    case types.USER_LOGOUT:
      return initialState;

    default:
      return state;
  }
}
